import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Cookie from 'utils/cookies';
import s from './StayUpdatedWidget.scss';
import InterSectionBorder from '../../../../../components_v2/common/InterSectionBorder/InterSectionBorder';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';
import { TOI_LIVE_DOMAIN } from './../../../../../constants';

const StayUpdated = ({ sectionData, ga4Type, ga4Label, ga4Category }) => {
  const grxId = Cookie?.get('_grx') || '';

  return (
    <>
      <InViewObserver
        inViewCallback={() =>
          analyticsWrapper('ga4', {
            event: 'user_shown',
            type: ga4Type || '',
            label: ga4Label || '',
            category: ga4Category || '',
            user_grx_id: grxId,
          })
        }
      >
        {sectionData?.border === 'top' && (
          <InterSectionBorder border={sectionData?.border} />
        )}
        <div className={s.liveTvEntry}>
          <div className={s.iconText}>
            <i className={s.liveTvColorIcon} />
            <span>Stay Updated on Latest News</span>
          </div>
          <a
            href={`${TOI_LIVE_DOMAIN}/live-tv`}
            target="_blank"
            rel="noopener noreferrer"
            className={s.btn}
            onClick={() => {
              analyticsWrapper('ga4', {
                event: 'user_click',
                type: ga4Type || 'web-live-tv-widget',
                label: ga4Label || 'livetv',
                category: ga4Category || 'LHS_homelineup',
              });
            }}
          >
            Watch Now
          </a>
        </div>
        {sectionData?.border === 'bottom' && (
          <InterSectionBorder border={sectionData?.border} />
        )}
      </InViewObserver>
    </>
  );
};

const mapStateToProps = state => ({
  userData: state.login.userData,
});

StayUpdated.propTypes = {
  sectionData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    id: PropTypes.string,
    subSections: PropTypes.shape({ dataUrl: PropTypes.string }),
  }),
  userData: PropTypes.shape({}),
  ga4Type: PropTypes.string,
  ga4Label: PropTypes.string,
  ga4Category: PropTypes.string,
};

StayUpdated.defaultProps = {
  sectionData: {},
  userData: {},
  ga4Type: '',
  ga4Label: '',
  ga4Category: '',
};

export default connect(mapStateToProps, null)(StayUpdated);
